"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHideFormOnCustomerIdChange = void 0;
var _react = require("react");
const useHideFormOnCustomerIdChange = (hideForm, customerId, condition = true) => {
  (0, _react.useEffect)(() => {
    if (condition) {
      hideForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we not needed update on other property
  }, [customerId]);
};
exports.useHideFormOnCustomerIdChange = useHideFormOnCustomerIdChange;
